/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_DescriptionInputs */



/**
* | output |
* | --- |
* | "Import markers from JSON or EDL files and configure import settings" |
*
* @param {Marker_Import_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_description = /** @type {((inputs?: Marker_Import_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer des marqueurs depuis des fichiers JSON ou EDL et configurer les parametres d'importation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importieren Sie Marker aus JSON- oder EDL-Dateien und konfigurieren Sie die Importeinstellungen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa marcatori da file JSON o EDL e configura le impostazioni di importazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импортируйте маркеры из файлов JSON или EDL и настройте параметры импорта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar marcadores desde archivos JSON o EDL y configurar los ajustes de importación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从 JSON 或 EDL 文件导入标记并配置导入设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("JSON または EDL ファイルからマーカーをインポートし、インポート設定を構成します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("JSON या EDL फ़ाइलों से मार्कर आयात करें और आयात सेटिंग्स कॉन्फ़िगर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importe marcadores de arquivos JSON ou EDL e configure as opções de importação.")
	return /** @type {LocalizedString} */ ("Import markers from JSON or EDL files and configure import settings")
});